import * as React from 'react'
const SvgComponent = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={172}
    height={169}
    shapeRendering="geometricPrecision"
    vectorEffect="non-scaling-stroke"
    preserveAspectRatio="xMidYMid meet"
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={172}
      height={117}
      x={0}
      y={52}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path fill="#fff" d="M171.802 52.054H.198V168.5h171.604V52.054Z" />
    </mask>
    <g mask="url(#a)">
      <mask
        id="b"
        width={172}
        height={117}
        x={0}
        y={52}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" d="M171.802 52.054H.198V168.5h171.604V52.054Z" />
      </mask>
    </g>
    <path
      fill="#fff"
      d="M148.575 74.496v.574l-33.224-19.183a11.923 11.923 0 0 0-11.934 0l-83.763 46.684h-2.652l.044 5.232a3.293 3.293 0 0 0 1.6 2.725l35.462 21.389a10.575 10.575 0 0 0 10.754.1l84.576-48.83a4.362 4.362 0 0 0 2.201-3.81V74.49h-3.07l.006.005Z"
    />
    <g opacity={0.8}>
      <mask
        id="d"
        width={136}
        height={80}
        x={16}
        y={54}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" d="M151.795 54.127H16.84v79.467h134.955V54.126Z" />
      </mask>
      <g mask="url(#d)">
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.75}
          shapeRendering="geometricPrecision"
          vectorEffect="non-scaling-stroke"
          d="M148.574 74.496v.574l-33.223-19.183a11.923 11.923 0 0 0-11.934 0l-83.763 46.684h-2.652l.044 5.232a3.293 3.293 0 0 0 1.6 2.725l35.462 21.389a10.575 10.575 0 0 0 10.753.1l84.577-48.83a4.364 4.364 0 0 0 2.201-3.81V74.49h-3.07l.005.005Z"
        />
      </g>
    </g>
    <path
      fill="#fff"
      d="M103.417 50.979 18.701 99.89c-2.195 1.265-2.223 4.424-.056 5.728l35.463 21.389a10.572 10.572 0 0 0 10.753.101l84.577-48.83c2.936-1.693 2.936-5.928 0-7.621l-34.087-19.68a11.924 11.924 0 0 0-11.934 0Z"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.75}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M103.417 50.979 18.701 99.89c-2.195 1.265-2.223 4.424-.056 5.728l35.463 21.389a10.572 10.572 0 0 0 10.753.101l84.577-48.83c2.936-1.693 2.936-5.928 0-7.621l-34.087-19.68a11.924 11.924 0 0 0-11.934 0Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.75}
      d="m142.892 68.925 5.655 3.265a2.593 2.593 0 0 1 1.309 2.267c0 .948-.49 1.794-1.309 2.268L63.97 125.554a8.819 8.819 0 0 1-4.396 1.176 8.914 8.914 0 0 1-4.54-1.265L19.57 104.076a1.52 1.52 0 0 1-.747-1.332c0-.262.084-.925.77-1.32l84.715-48.913a10.13 10.13 0 0 1 5.076-1.36c1.783 0 3.532.468 5.07 1.36l5.293 3.059"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.75}
      d="m119.753 55.57-.485.646a1.419 1.419 0 0 0 .379 2.134l18.72 10.887a3.3 3.3 0 0 0 2.792.25l1.732-.562"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.75}
      d="m132.551 63.804-7.132-4.128a.31.31 0 0 1-.017-.53.306.306 0 0 1 .329-.01l7.132 4.128a.31.31 0 0 1 .016.53.304.304 0 0 1-.328.01ZM136.423 66.05l-2.212-1.304a.31.31 0 0 1-.017-.53.306.306 0 0 1 .329-.01l2.212 1.303a.31.31 0 0 1 .017.53.306.306 0 0 1-.329.01ZM140.323 86.28l-4.53 2.613a.327.327 0 1 1-.323-.568l4.53-2.613a.327.327 0 0 1 .49.284.325.325 0 0 1-.161.284h-.006ZM115.407 101.062l-4.53 2.613a.327.327 0 1 1-.323-.569l4.53-2.613a.327.327 0 0 1 .49.284.326.326 0 0 1-.162.285h-.005ZM39.494 121.637l-7.182-4.145a.363.363 0 0 1-.178-.312v-1.398a.2.2 0 0 1 .295-.173l7.132 4.117a.42.42 0 0 1 .212.363v1.381a.186.186 0 0 1-.279.162v.005Z"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <g opacity={0.15}>
      <mask
        id="e"
        width={8}
        height={6}
        x={32}
        y={115}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" d="M39.773 115.587h-7.64v5.298h7.64v-5.298Z" />
      </mask>
      <g mask="url(#e)">
        <path
          fill="#000"
          d="m39.566 119.732-7.131-4.117a.195.195 0 0 0-.296.172v1.399c0 .106.05.2.129.273l.74-.552 6.77 3.984v-.791a.41.41 0 0 0-.212-.363"
          shapeRendering="geometricPrecision"
          vectorEffect="non-scaling-stroke"
        />
      </g>
    </g>
    <g opacity={0.1}>
      <mask
        id="f"
        width={11}
        height={8}
        x={54}
        y={126}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" d="M64.527 126.997H54.114v6.48h10.413v-6.48Z" />
      </mask>
      <g mask="url(#f)">
        <path
          fill="#000"
          d="M54.108 126.997v4.926s5.784 3.298 10.414.289c0-1.047-.14-4.853-.14-4.853s-3.666 1.455-5.655 1.159c-2.986-.445-4.613-1.521-4.613-1.521"
          shapeRendering="geometricPrecision"
          vectorEffect="non-scaling-stroke"
        />
      </g>
    </g>
    <g opacity={0.1}>
      <mask
        id="g"
        width={132}
        height={53}
        x={18}
        y={51}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" d="M149.856 51.068H18.824v52.835h131.032V51.068Z" />
      </mask>
      <g mask="url(#g)">
        <path
          fill="#000"
          d="m148.463 72.061-5.571-3.22-1.733.563a3.318 3.318 0 0 1-2.792-.251L119.14 58.004l-.217-.535.111.062a1.411 1.411 0 0 1 .234-1.404l.485-.652-5.293-3.06a10.124 10.124 0 0 0-5.07-1.359c-1.778 0-3.533.468-5.076 1.36l-84.716 48.913a1.509 1.509 0 0 0-.769 1.32c0 .245.061.836.624 1.248.045-.033.09-.067.145-.1l84.716-48.907a10.13 10.13 0 0 1 5.076-1.36c1.783 0 3.532.468 5.07 1.36l4.373 2.524c-.011.362.001 1.331.045 2.061.028.518.318.992.769 1.248h.006l18.72 10.887c.847.49 1.872.585 2.791.25l1.733-.562 5.655 3.265c.435.25.775.607.998 1.03.239-.445.351-.958.295-1.504-.089-.858-.63-1.604-1.376-2.039"
          shapeRendering="geometricPrecision"
          vectorEffect="non-scaling-stroke"
        />
      </g>
    </g>
    <g opacity={0.15}>
      <mask
        id="h"
        width={38}
        height={22}
        x={69}
        y={81}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" d="M106.76 81.684H69.943v21.255h36.817V81.684Z" />
      </mask>
      <g mask="url(#h)">
        <path
          fill="#000"
          d="M101.405 99.847c-7.165 4.134-18.82 4.117-26.03-.045-7.21-4.162-7.249-10.892-.084-15.026 7.166-4.14 18.821-4.118 26.031.044 7.21 4.162 7.249 10.893.083 15.027Z"
          shapeRendering="geometricPrecision"
          vectorEffect="non-scaling-stroke"
        />
      </g>
    </g>
    <path
      fill="#fff"
      d="m107.111 82.803-.914 1.143c-.925-1.7-2.546-3.304-4.875-4.658-7.678-4.457-20.091-4.48-27.724-.05-2.43 1.41-4.079 3.103-4.959 4.903l-.741-1.076V87.2c-.017 2.936 1.911 5.877 5.783 8.128 7.678 4.458 20.091 4.48 27.724.05 3.778-2.19 5.672-5.058 5.695-7.939v-4.63l.011-.005Z"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.75}
      d="m107.111 82.803-.914 1.143c-.925-1.7-2.546-3.304-4.875-4.658-7.678-4.457-20.091-4.48-27.724-.05-2.43 1.41-4.079 3.103-4.959 4.903l-.741-1.076V87.2c-.017 2.936 1.911 5.877 5.783 8.128 7.678 4.458 20.091 4.48 27.724.05 3.778-2.19 5.672-5.058 5.695-7.939v-4.63l.011-.005Z"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      fill="#fff"
      d="M101.467 91.116c-7.672 4.43-20.147 4.407-27.864-.05-7.716-4.457-7.755-11.661-.089-16.09 7.672-4.43 20.147-4.408 27.864.05 7.716 4.457 7.755 11.66.089 16.085"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.75}
      d="M101.467 91.116c-7.672 4.43-20.147 4.407-27.864-.05-7.716-4.457-7.755-11.661-.089-16.09 7.672-4.43 20.147-4.408 27.864.05 7.716 4.457 7.755 11.66.089 16.085v.005Z"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.75}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M99.65 89.695c-6.674 3.85-17.528 3.834-24.242-.044-6.713-3.878-6.747-10.146-.078-13.996 6.675-3.855 17.529-3.833 24.243.045 6.713 3.877 6.747 10.146.078 13.995Z"
    />
    <path
      fill="#000"
      d="M88.619 82.675c-.44.257-1.16.251-1.6 0-.445-.256-.445-.668 0-.925.44-.256 1.16-.25 1.6 0 .445.257.445.669 0 .925Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.75}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="m95.962 78.536-6.786 3.014M89.064 82.731l5.929 1.688M88.875 68.54c5.806.296 11.477 1.727 15.935 4.301"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.75}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="m89.99 67.649-1.254.835 1.07 1.065M79.732 102.911c-5.616-1.499-10.865-4.084-14.687-7.533"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.75}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="m78.456 103.547 1.399-.552-.825-1.265"
    />
    <path
      fill="#fff"
      d="m48.13 38.727 18.236-28.354L51.35 1.536s-.033-.022-.055-.028l-.162-.089c-2.117-1.175-5.031-1.025-8.29.725-6.737 3.621-12.38 12.714-12.609 20.308-.1 3.282.83 5.744 2.463 7.193h.005c.396.351 15.434 9.076 15.434 9.076"
    />
    <g opacity={0.8}>
      <mask
        id="i"
        width={37}
        height={39}
        x={30}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" d="M66.522.5H30.067v38.383h36.455V.5Z" />
      </mask>
      <g mask="url(#i)">
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.75}
          d="m48.13 38.727 18.236-28.354L51.35 1.536s-.033-.022-.055-.028l-.162-.089c-2.117-1.175-5.031-1.025-8.29.725-6.737 3.621-12.38 12.714-12.609 20.308-.1 3.282.83 5.744 2.463 7.193h.005c.396.351 15.434 9.076 15.434 9.076l-.006.006Z"
        />
      </g>
    </g>
    <g opacity={0.1}>
      <mask
        id="j"
        width={27}
        height={20}
        x={30}
        y={19}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" d="M56.036 19.566H30.223v19.35h25.813v-19.35Z" />
      </mask>
      <g mask="url(#j)">
        <path
          fill="currentColor"
          className="gray-element"
          d="M30.59 19.566c-.551 2.162-.311 2.357-.323 4.38-.022 3.42 2.302 5.933 2.302 5.933.423.312 3.47 2.112 4.111 2.401l11.985 6.636 7.382-4.44c-5.304-2.552-17.177-7.628-22.024-10.553-.418-.25-.836-.501-1.27-.719-.714-.35-2.129-1.337-2.151-3.638"
        />
      </g>
    </g>
    <path
      fill="#fff"
      d="M67.915 17.07c-.947 7.143-6.603 16.235-12.626 20.297-6.022 4.067-10.14 1.571-9.187-5.577.953-7.148 6.602-16.236 12.625-20.297 6.023-4.068 10.14-1.572 9.188 5.577Z"
    />
    <g opacity={0.8}>
      <mask
        id="k"
        width={24}
        height={31}
        x={45}
        y={9}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="currentColor"
          d="M68.21 9.387H45.807v30.092H68.21V9.387Z"
          className="gray-element"
        />
      </mask>
      <g mask="url(#k)">
        <path
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.75}
          d="M67.915 17.07c-.948 7.143-6.603 16.235-12.626 20.297-6.023 4.067-10.14 1.571-9.187-5.577.953-7.148 6.602-16.236 12.625-20.297 6.023-4.068 10.14-1.572 9.188 5.577Z"
        />
      </g>
    </g>
    <path
      fill="#fff"
      d="M61.452 10.15c7.388 2.329 13.099 4.713 19.695 8.775 3.293 2.028 6.218 4.123 7.299 5.711 2.992 4.402 5.828 10.82 5.845 12.324.027 2.73-2.73 2.992-2.73 2.992l-13.512 7.745"
    />
    <g opacity={0.8}>
      <mask
        id="l"
        width={34}
        height={39}
        x={61}
        y={9}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" d="M94.452 9.988H61.29v37.865h33.162V9.988Z" />
      </mask>
      <g mask="url(#l)">
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.75}
          d="M61.452 10.15c7.388 2.329 13.098 4.713 19.695 8.775 3.293 2.028 6.218 4.123 7.299 5.711 2.992 4.402 5.828 10.82 5.844 12.324.028 2.73-2.73 2.992-2.73 2.992l-13.51 7.745"
        />
      </g>
    </g>
    <g opacity={0.1}>
      <mask
        id="m"
        width={8}
        height={8}
        x={87}
        y={32}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" d="M94.23 32.615h-6.737v7.32h6.736v-7.32Z" />
      </mask>
      <g mask="url(#m)">
        <path
          fill="#000"
          d="M94.207 36.487s-2.1 5.744-6.714-3.872c2.53 6.195 2.742 7.265 2.742 7.265s4.356.763 3.972-3.393Z"
        />
      </g>
    </g>
    <path
      fill="#fff"
      d="m63.864 40.61 1.544 6.697s5.148 3.126 7.967 5.544c1.109.953 1.52 1.933 1.616 2.78.133 1.181-1.059 2.084-2.184 1.694-3.722-1.282-12.135-4.38-12.765-5.004-.97-.963-4.596-8.05-6.68-11.79a12.803 12.803 0 0 0-3.126-3.72l-4.206-2.452"
    />
    <g opacity={0.8}>
      <mask
        id="n"
        width={31}
        height={24}
        x={45}
        y={34}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" d="M75.152 34.197H45.868v23.378h29.284V34.197Z" />
      </mask>
      <g mask="url(#n)">
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.75}
          d="m63.864 40.61 1.544 6.697s5.148 3.126 7.967 5.544c1.109.953 1.52 1.933 1.616 2.78.133 1.181-1.059 2.084-2.184 1.694-3.722-1.282-12.135-4.38-12.765-5.004-.97-.963-4.596-8.05-6.68-11.79a12.803 12.803 0 0 0-3.126-3.72l-4.206-2.452"
        />
      </g>
    </g>
    <path
      fill="#fff"
      d="M87.627 29.65c.384.953 4.117 10.637 4.29 11.946.329 2.507-.791 4.157-3.894 3.7 0 0-2.012-1.31-3.104-3.17"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.75}
      d="M87.627 29.65c.384.953 4.117 10.637 4.29 11.946.329 2.507-.791 4.157-3.894 3.7 0 0-2.012-1.31-3.104-3.17"
    />
    <path
      fill="#fff"
      d="M84.457 35.261c.256.624 4.117 10.636 4.29 11.946.329 2.507-1.248 4.234-4.346 3.772 0 0-5.026-2.847-6.346-7.271"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.75}
      d="M84.457 35.261c.256.624 4.117 10.636 4.29 11.946.329 2.507-1.248 4.234-4.346 3.772 0 0-5.026-2.847-6.346-7.271"
    />
    <path
      fill="#fff"
      d="M80.183 39.156c.078.19 3.41 9.115 4.346 12.107.184.596.267 1.209.256 1.833l-.757 14.826c-.028 1.415-1.633 2.223-2.78 1.393-1.488-1.081-3.01-2.117-3.344-8.697-.256-5.684-.15-6.43-.15-6.43l-5.287-8.993-10.135-4.947"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.75}
      d="M80.183 39.156c.078.19 3.41 9.115 4.346 12.107.184.596.267 1.209.256 1.833l-.757 14.826c-.028 1.415-1.633 2.223-2.78 1.393-1.488-1.081-3.01-2.117-3.344-8.697-.256-5.684-.15-6.43-.15-6.43l-5.287-8.993-10.135-4.947"
    />
    <g opacity={0.1}>
      <mask
        id="o"
        width={8}
        height={9}
        x={81}
        y={43}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" d="M88.641 43.747h-6.714v7.31h6.714v-7.31Z" />
      </mask>
      <g mask="url(#o)">
        <path
          fill="#000"
          d="M88.557 47.318s-2.719 4.791-6.635-3.571c2.53 6.195 2.74 7.265 2.74 7.265s4.63.707 3.895-3.7"
        />
      </g>
    </g>
    <path
      fill="#fff"
      d="M66.31 17.65c-.178.044-15.093 17.69-14.96 17.778.134.09 4.402 4.708 4.402 4.708l4.424 1.237s1.03-2.039 2.54-1.354c2.207.998 4.485 2.368 4.57 2.318.06-.039 5.253-.262 7.989-2.256 3.36-2.452 4.373-6.759 4.373-6.759L66.316 17.65h-.006Z"
    />
    <g opacity={0.15}>
      <mask
        id="p"
        width={23}
        height={31}
        x={45}
        y={9}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" d="M67.424 9.543H45.88v29.774h21.545V9.543Z" />
      </mask>
      <g mask="url(#p)">
        <path
          fill="currentColor"
          d="M49.818 34.175c.947-7.143 5.416-15.88 12.625-20.297 1.299-.797 2.229-1.293 3.276-1.644.452-.15 1.037-.1 1.254-.14.267-.044.54.357.418-.161-1.27-2.908-4.547-3.276-8.753-.435-6.023 4.068-11.678 13.155-12.625 20.298-.658 4.936 1.103 7.65 4.24 7.521.523 0 1.994-.133 1.91-.473-.072-.284-1.938-1.895-2.122-2.246-.446-.846-.39-1.18-.223-2.423Z"
        />
      </g>
    </g>
    <g opacity={0.1}>
      <mask
        id="q"
        width={7}
        height={8}
        x={85}
        y={38}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" d="M91.995 38.03h-6.714v7.31h6.714v-7.31Z" />
      </mask>
      <g mask="url(#q)">
        <path
          fill="#000"
          d="M91.917 41.602s-2.719 4.791-6.636-3.572c2.53 6.196 2.742 7.266 2.742 7.266s4.63.707 3.894-3.7"
        />
      </g>
    </g>
    <defs>
      <pattern
        id="c"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#r" transform="scale(.00324 .00476)" />
      </pattern>
      <image
        xlinkHref="data:image/png;base64,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"
        id="r"
        width={309}
        height={210}
        preserveAspectRatio="none"
      />
    </defs>
  </svg>
)
export default SvgComponent
